import {useCallback, useState} from "react";
import {useDispatch} from "react-redux";
import {isEmpty} from "lodash";
import {
  deleteInventoryData,
  simDropdown,
  storeEditInventoryData,
  systemProfile,
  toggleInventoryCommission,
} from "../../../redux/Actions/inventory.actions";
import {useFetchInventories} from "./useInventoryTableData";

export const useInventoryTableActions = (fetchAfterDelete = () => {}) => {
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [editModalStatus, setEditModalStatus] = useState(false);
  const [commissionModalStatus, setCommissionModalStatus] = useState(false);
  const [selectedInventoryId, setSelectInventory] = useState("");
  const [selectedCommissionMac, setSelectedCommissionMac] = useState("");
  const dispatch = useDispatch();
  const {refetch} = useFetchInventories();

  const handleEdit = useCallback(
    (data) => {
      const {mac = "", check_code = "", profileObject = {}, serial = "", sim = []} = data;
      const basicInfo = {
        serial,
        check_code,
        profile: !isEmpty(profileObject) ? profileObject?.value : "",
        selectedProfile: !isEmpty(profileObject) ? profileObject : {},
      };
      const detailedInfo = {
        mac,
        sim: !isEmpty(sim) ? sim[0].value : "",
        selectedSim: !isEmpty(sim) ? sim[0] : {},
      };
      const sendEditData = {basicInfo, detailedInfo};
      dispatch(storeEditInventoryData(sendEditData));
      dispatch(simDropdown());
      dispatch(systemProfile());
      setEditModalStatus(true);
    },
    [dispatch]
  );

  const handleDelete = (id) => {
    setDeleteModalStatus(true);
    setSelectInventory(id);
  };

  const deleteInventory = () => {
    const callback = () => {
      setDeleteModalStatus(false);
      setSelectInventory("");
      fetchAfterDelete();
    };
    dispatch(deleteInventoryData(selectedInventoryId, callback));
  };

  const handleCommissionDevice = (mac) => {
    setCommissionModalStatus(true);
    setSelectedCommissionMac(mac);
  };

  const commissionDevice = () => {
    const callback = () => {
      setCommissionModalStatus(false);
      setSelectedCommissionMac("");
      refetch();
    };
    dispatch(toggleInventoryCommission(selectedCommissionMac, callback));
  };

  const handleActionSelection = useCallback(
    (action, data) => {
      switch (action) {
        case "Edit":
          handleEdit(data);
          break;
        case "Delete":
          handleDelete(data.mac);
          break;
        case "Commission Device":
          handleCommissionDevice(data.mac);
          break;
      }
    },
    [handleEdit]
  );
  return {
    commissionDevice,
    commissionModalStatus,
    deleteInventory,
    deleteModalStatus,
    editModalStatus,
    handleActionSelection,
    selectedInventoryId,
    setCommissionModalStatus,
    setDeleteModalStatus,
    setEditModalStatus,
  };
};
